export default "__VITE_ASSET__tL4Y$MR6__"